/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { ResetPasswordOptions, ResetPasswordResponses } from '../../models/ResetPassword'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Reset Password
 * {@link /auth/reset-password}
 */
export function resetPassword<ThrowOnError extends boolean = true>(options: Options<ResetPasswordOptions, ThrowOnError>): Promise<UnwrappedResult<ResetPasswordResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'POST', url: '/auth/reset-password', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<ResetPasswordResponses, ThrowOnError>>
}
